import React from 'react';
import { makeStyles } from '@branchjs/neo-components';
import { ImageService } from '../../services/ImageService/ImageService';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  icon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
  },
}));

const AdsUnifiedTab = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <img className={classes.icon} src={ImageService.getImageUrl('/static/images/skan_icon.svg')} />
      Unified
    </div>
  );
};

export default AdsUnifiedTab;
